
import {
  LayoutDashboard,
  Briefcase,
  Search,
  Brain,
  Wrench,
  ListChecks,
  FileText,
  Code,
  BarChart3,
  Mail,
  Type,
  UserPlus,
  Link2,
  User,
  Settings,
  MessageSquare,
  Users,
  Book,
  HelpCircle,
  LucideIcon,
  Layout,
  Image,
  GaugeCircle,
  PanelLeft,
  QrCode,
  FileImage,
  PaintBucket,
  Activity,
  Table,
  MousePointerClick,
  Megaphone,
  Zap,
} from "lucide-react";
import { MenuItem } from "./types/menu-item";

export const marketingBusinessItems: MenuItem[] = [
  {
    id: "biz-name-gen",
    title: "BizNameGen",
    url: "/biz-name-gen",
    icon: Briefcase,
    available: true,
    reliability: 4,
  },
  {
    id: "utm-magic",
    title: "UTMagic",
    url: "/utm-magic",
    icon: Link2,
    available: true,
    reliability: 4,
  },
  {
    id: "gen-persona",
    title: "GenPersona",
    url: "/gen-persona",
    icon: UserPlus,
    available: true,
    reliability: 3,
  },
  {
    id: "email-score",
    title: "EmailScore",
    url: "/email-score",
    icon: Mail,
    available: true,
    reliability: 3,
  },
  {
    id: "roi-quick",
    title: "ROIQuick",
    url: "/roi-quick",
    icon: BarChart3,
    available: true,
    reliability: 4,
  },
  {
    id: "profit-pilot",
    title: "ProfitPilot",
    url: "/profit-pilot",
    icon: Activity,
    available: true,
    reliability: 3,
  },
  {
    id: "converticalc",
    title: "ConvertiCalc",
    url: "/converticalc",
    icon: BarChart3,
    available: true,
    reliability: 4,
  },
  {
    id: "evorate",
    title: "Evorate",
    url: "/evorate",
    icon: Type,
    available: true,
    reliability: 3,
  },
  {
    id: "funnel-flow",
    title: "FunnelFlow",
    url: "/funnel-flow",
    icon: BarChart3,
    available: true,
    reliability: 3,
  },
  {
    id: "qrna",
    title: "QRna",
    url: "/qrna",
    icon: QrCode,
    available: true,
    reliability: 3,
  },
];

export const seoItems: MenuItem[] = [
  {
    id: "keyword-check",
    title: "KeywordCheck",
    url: "/keyword-check",
    icon: Search,
    available: true,
    reliability: 4,
  },
  {
    id: "pagespeed-check",
    title: "PageSpeedCheck",
    url: "/pagespeed-check",
    icon: GaugeCircle,
    available: true,
    reliability: 3,
  },
  {
    id: "fairclick",
    title: "FairClick",
    url: "/fairclick",
    icon: MousePointerClick,
    available: true,
    reliability: 3,
  },
  {
    id: "snippet-view",
    title: "SnippetView",
    url: "/snippet-view",
    icon: Code,
    available: true,
    reliability: 3,
  },
  {
    id: "shortatrack",
    title: "ShortaTrack",
    url: "/shortatrack",
    icon: Link2,
    available: true,
    reliability: 3,
  },
];

export const productivityItems: MenuItem[] = [
  {
    id: "todo-boost",
    title: "ToDoBoost",
    url: "/todo-boost",
    icon: ListChecks,
    available: true,
    reliability: 4,
  },
  {
    id: "checklista",
    title: "CheckLista",
    url: "/checklista",
    icon: ListChecks,
    available: true,
    reliability: 3,
  },
  {
    id: "formugen",
    title: "FormuGen",
    url: "/formugen",
    icon: FileText,
    available: true,
    reliability: 3,
  },
  {
    id: "planifica",
    title: "Planifica",
    url: "/planifica",
    icon: Layout,
    available: true,
    reliability: 3,
  },
  {
    id: "tabliwizz",
    title: "TabliWizz",
    url: "/tabliwizz",
    icon: Table,
    available: true,
    reliability: 3,
  },
];

export const utilitiesItems: MenuItem[] = [
  {
    id: "compressapic",
    title: "CompressaPic",
    url: "/compressapic",
    icon: FileImage,
    available: true,
    reliability: 3,
  },
  {
    id: "canvasbuilder",
    title: "CanvasBuilder",
    url: "/canvasbuilder",
    icon: PaintBucket,
    available: true,
    reliability: 3,
  },
  {
    id: "quizngo",
    title: "QuizNGo",
    url: "/quizngo",
    icon: Zap,
    available: true,
    reliability: 3,
  },
];

export const accountItems: MenuItem[] = [
  {
    id: "dashboard",
    title: "Tableau de bord",
    url: "/dashboard",
    icon: LayoutDashboard,
    available: true,
    requiresAuth: true
  },
  {
    id: "settings",
    title: "Paramètres",
    url: "/settings",
    icon: Settings,
    available: true,
    requiresAuth: true
  },
  {
    id: "faq",
    title: "FAQ",
    url: "/faq",
    icon: HelpCircle,
    available: true,
    requiresAuth: true
  },
  {
    id: "partners",
    title: "Partenaires",
    url: "/partners",
    icon: Users,
    available: true,
    requiresAuth: true
  },
  {
    id: "blog",
    title: "Blog",
    url: "/blog",
    icon: Book,
    available: true,
    requiresAuth: true
  },
];

export const adminMenuItems: MenuItem[] = [
  {
    id: "admin-dashboard",
    title: "Admin Dashboard",
    url: "/admin-dashboard",
    icon: PanelLeft,
    available: true,
    adminOnly: true,
  },
  {
    id: "blog-editor",
    title: "Blog Editor",
    url: "/blog/editor",
    icon: FileText,
    available: true,
    adminOnly: true,
  },
  {
    id: "ad-zones",
    title: "Zones publicitaires",
    url: "/admin-dashboard#ad-zones",
    icon: Megaphone,
    available: true,
    adminOnly: true,
  },
];
